import {
    obiektListDeleteStoredStateByType,
    obiektListFilterCreateComplete,
    obiektListFilterDeleteComplete,
    obiektListGetFilter,
    obiektListOpenAndSetUnappliedFilterComplete,
    obiektListReferrerUrl,
    obiektListRestoreStateByType,
    obiektListSetCurrentFilter,
    obiektListSetDefaultStateByTypeComplete, obiektListSetSubListParentObiektId,
    obiektListUpdateColumnVisibility,
    obiektListUpdateColumnWidth,
    obiektListUpdateEditedItems,
    obiektListUpdateFilterClose,
    obiektListUpdateFilterData,
    obiektListUpdateFilterName,
    obiektListUpdateFilterOpen,
    obiektListUpdateFilterVisibility,
    obiektListUpdateLockData,
    obiektListUpdatePagination,
    obiektListUpdateSelectedRows,
    obiektListUpdateSort
} from './obiekt-list.actions';
import {
    FilterDataState,
    IdsByType,
    ListDataState,
    LockDataState,
    ObiektListState,
    ObiektListStateByType,
    ObiektListStatePart
} from './obiekt-list.model';
import _ from 'lodash';
import { assign } from '../../../../lib/assign';
import { Display } from '../../../ladon-api-enums/WK.Ladon.Cms.Read.Model.List.Definition.Enum.Display';
import { Sort } from '../../../common/model/WK.Ladon.Cms.Read.Model.List.Sort';
import { DisplayOptions } from '../../../common/model/WK.Ladon.Cms.Read.Model.List.Definition.DisplayOptions';
import { FilterOptions } from '../../../common/model/WK.Ladon.Cms.Read.Model.List.Definition.FilterOptions';
import {
    metadataPreviewClose,
    metadataPreviewInitialize,
    metadataPreviewOpenComplete,
    metadataPreviewOpenStart,
    metadataPreviewPanelClose,
    metadataPreviewShowTrescForJednostkaAktu
} from './metadata-preview/metadata-preview.actions';
import { MetadataPreviewPanel, PreviewState } from './metadata-preview/metadata-preview.model';
import { StringFilterValue } from '../../../common/model/WK.Ladon.Cms.Read.Model.List.StringFilterValue';
import { createReducer, on } from '@ngrx/store';
import { ColumnsNameHelper } from '../../columns-name-helper';

const INITIAL_STATE_PART: ObiektListStatePart = {
    filterId: null,
    filterOwnerUserId: null,
    filterName: null,
    data: {
        filterData: {
            openMetadataId: null,
            values: [],
            visibleMetadataIds: [],
            unappliedValue: null
        },
        listData: {
            visibleMetadataIds: [],
            columnWidths: [],
            sorts: [],
            selectedIds: [],
            pagination: {page: 1, itemsPerPage: 100},
            editedItems: [],
            metadataPreview: {
                id: null,
                open: false,
                panels: [],
                previousPanels: []
            }
        }
    }
};
const INITIAL_LOCK_COLUMN_DATA_STATE: LockDataState = {
    rowIdentifier: null,
    lockColumnsData: []
};

const INITIAL_STATE: ObiektListState = {
    referrerUrl: null,
    jednostkaAktuForTrescPreview: null,

    listDefinitionType: null,
    currentList: INITIAL_STATE_PART,
    stateByType: {},
    selectedIdsByType: {},
    loading: false,
    lockData: INITIAL_LOCK_COLUMN_DATA_STATE,
    subListData: null
};

export function updateFilterData(state: ObiektListStatePart, filterData: Partial<FilterDataState>): ObiektListStatePart {
    return assign(state, {
        data: assign(state.data, {
            filterData: assign(state.data.filterData, filterData)
        })
    });
}

export function updateListData(state: ObiektListStatePart, listData: Partial<ListDataState>): ObiektListStatePart {
    return assign(state, {
        data: assign(state.data, {
            listData: assign(state.data.listData, listData)
        })
    });
}

export function updateMetadataPreview(state: ObiektListStatePart, metadataPreview: Partial<PreviewState>): ObiektListStatePart {
    return updateListData(state, {
        metadataPreview: assign(state.data.listData.metadataPreview, metadataPreview)
    });
}

export function updateCurrentListState(state: ObiektListState, updatedFilterState: ObiektListStatePart): ObiektListState {
    if (state.listDefinitionType === null) {
        return state;
    }
    const stateByType: ObiektListStateByType = {};
    stateByType[ state.listDefinitionType ] = updatedFilterState;
    return assign(state, {
        currentList: updatedFilterState,
        stateByType: assign(state.stateByType, stateByType),
        subListData: state.subListData !== null && state.subListData.listDefinitionType === state.listDefinitionType ? state.subListData : null
    });
}

export function getCurrentListState(state: ObiektListState): ObiektListStatePart {
    let currentListState: ObiektListStatePart;
    if (state.listDefinitionType !== null) {
        currentListState = state.stateByType[ state.listDefinitionType ];
    }
    //
    // currentListState = currentListState === undefined || currentListState === null ? INITIAL_STATE_PART : currentListState;
    // if (state.currentList && state.currentList.subListParentObiektId) {
    //     currentListState = assign(currentListState, {
    //         subListParentObiektId: state.currentList.subListParentObiektId
    //     });
    // }
    //
    // return currentListState;
    return currentListState === undefined || currentListState === null ? INITIAL_STATE_PART : currentListState;
}

export const obiektListReducer = createReducer(
    INITIAL_STATE,
    on(obiektListGetFilter, (state, {id}) => assign(state, {loading: true})),
    on(obiektListUpdateFilterData, (state, {values}) => {
        const currentState = getCurrentListState(state);
        const modifiedValues = values.map(v => {
            if ((v.metadataId === 'TytulyOrzeczen_Tytul' || v.metadataId === 'Orzeczenie_Tytul') && v.value.value) {
                const filterValue = v.value as StringFilterValue; // tytuł jest stringiem
                return {
                    metadataId: v.metadataId,
                    value: {value: filterValue.text.replace(new RegExp('"(.*?)"'), '„$1”')}
                };
            } else {
                return v;
            }
        });

        // sprawdzanie czy podano wartość niezatwierdzonego filtra
        let notConfirmedValue = null;
        if (currentState.data.filterData.unappliedValue !== null) {
            if (!values.map(v => v.metadataId).includes(currentState.data.filterData.unappliedValue.metadataId)) {
                // jak nie podano to bez zmian
                notConfirmedValue = currentState.data.filterData.unappliedValue;
            }
        }

        const updatedState = assign(currentState, {
            data: assign(currentState.data, {
                listData: assign(currentState.data.listData, {
                    editedItems: []
                }),
                filterData: assign(currentState.data.filterData, {
                    values: modifiedValues,
                    unappliedValue: notConfirmedValue
                })
            })
        });

        const stateByType: ObiektListStateByType = {};
        stateByType[ state.listDefinitionType ] = updatedState;

        return assign(state, {
            currentList: updatedState,
            stateByType: assign(state.stateByType, stateByType)
        });

    }),
    on(obiektListOpenAndSetUnappliedFilterComplete, (state, {value}) => {
        // otwieranie niezatwierdzonego filtra
        const currentState = getCurrentListState(state);

        // jak wskazanego filtra nie ma na liście widocznych to go dodajemy
        const visibleMetadataIds = currentState.data.filterData.visibleMetadataIds.includes(value.metadataId) ?
            currentState.data.filterData.visibleMetadataIds : [value.metadataId, ...currentState.data.filterData.visibleMetadataIds];
        const updatedState = assign(currentState, {
            data: assign(currentState.data, {
                listData: assign(currentState.data.listData, {
                    editedItems: [],
                }),
                filterData: assign(currentState.data.filterData, {
                    unappliedValue: value,
                    openMetadataId: value.metadataId,
                    visibleMetadataIds: visibleMetadataIds
                })
            })
        });

        const stateByType: ObiektListStateByType = {};
        stateByType[ state.listDefinitionType ] = updatedState;

        return assign(state, {
            currentList: updatedState,
            stateByType: assign(state.stateByType, stateByType)
        });
    }),
    on(obiektListUpdateFilterVisibility, (state, {visibleFilterIds}) => {
        const currentState = getCurrentListState(state);

        const difference = _.difference(visibleFilterIds, currentState.data.filterData.visibleMetadataIds);
        const openMetadataId = difference.length > 0 ? difference[ 0 ] : null;

        // Jeśli dodajemy filtr to nie zmieniamy wartości
        if (difference.length > 0) {
            const updatedFilterState = updateFilterData(currentState, {
                openMetadataId,
                visibleMetadataIds: visibleFilterIds
            });
            return updateCurrentListState(state, updatedFilterState);
        }
        // Jeśli chowamy filtr to kasujemy jego wartość
        const values = currentState.data.filterData.values.filter(x => visibleFilterIds.indexOf(x.metadataId) > -1);
        const updatedState = updateFilterData(currentState, {
            openMetadataId,
            visibleMetadataIds: visibleFilterIds,
            values
        });
        return updateCurrentListState(state, updatedState);
    }),
    on(obiektListUpdateFilterOpen, (state, {id}) => {
        const currentState = getCurrentListState(state);
        const updatedState = updateFilterData(currentState, {openMetadataId: id});
        return updateCurrentListState(state, updatedState);
    }),
    on(obiektListUpdateFilterClose, (state) => {
        const currentState = getCurrentListState(state);
        const updatedState = updateFilterData(currentState, {openMetadataId: null, unappliedValue: null});
        return updateCurrentListState(state, updatedState);
    }),
    on(obiektListUpdateFilterName, (state, {name}) => {
        const currentState = getCurrentListState(state);
        const updatedState = assign(currentState, {filterName: name});

        const stateByType: ObiektListStateByType = {};
        stateByType[ state.listDefinitionType ] = updatedState;

        return assign(state, {
            currentList: updatedState,
            stateByType: assign(state.stateByType, stateByType)
        });
    }),
    on(obiektListReferrerUrl, (state, {url}) => assign(state, {referrerUrl: url})),
    on(obiektListUpdateColumnVisibility, (state, {visibleColumnIds}) => {
        const currentState = getCurrentListState(state);
        const updatedState = updateListData(currentState, {visibleMetadataIds: visibleColumnIds});
        return updateCurrentListState(state, updatedState);
    }),
    on(obiektListUpdateSort, (state, {sort}) => {
        const currentState = getCurrentListState(state);
        const updatedState = updateListData(currentState, {sorts: sort});
        return updateCurrentListState(state, updatedState);
    }),
    on(obiektListUpdateColumnWidth, (state, {columnWidth}) => {
        const currentState = getCurrentListState(state);
        const updatedState = updateListData(currentState, {columnWidths: columnWidth});
        return updateCurrentListState(state, updatedState);
    }),
    on(obiektListUpdateSelectedRows, (state, {listDefinitionType, selectedIds}) => {
        const listState = state.stateByType[ listDefinitionType ];

        if (listState === undefined) {
            const selectedIdsByType: IdsByType = {};
            selectedIdsByType[ listDefinitionType ] = selectedIds;
            return assign(state, {selectedIdsByType: selectedIdsByType});
        } else {
            const updatedState = updateListData(listState, {selectedIds});

            // jak aktualnie wybranu filtr jest tego samego typu to aktualizujemy go i na liście
            if (state.listDefinitionType === listDefinitionType) {
                return updateCurrentListState(state, updatedState);
            } else {
                // jak nie jest wybrany, to aktualizujemy tylko na liście
                const stateByType: ObiektListStateByType = {};
                stateByType[ listDefinitionType ] = updatedState;
                return assign(state, {
                    stateByType: assign(state.stateByType, stateByType)
                });
            }
        }
    }),
    on(obiektListUpdatePagination, (state, {pagination}) => {
        const currentState = getCurrentListState(state);
        const updatedState = updateListData(currentState, {pagination});
        return updateCurrentListState(state, updatedState);
    }),
    on(obiektListFilterCreateComplete, (state, {filterId, filterName, filterOwnerUserId}) => {
        const currentState = getCurrentListState(state);
        const filterIdNazwaAndOwnerId: Readonly<{ filterId: number, filterName: string, filterOwnerUserId: number }> = {
            filterId,
            filterName,
            filterOwnerUserId
        };
        const updatedState = assign(currentState, filterIdNazwaAndOwnerId);
        return updateCurrentListState(state, updatedState);
    }),
    on(obiektListSetCurrentFilter, (state, {filter}) => {
        const currentState = getCurrentListState(state);

        // jak filtr się nie zmienia ta nie aktualizujemy jego stanu, tylko loading na false
        if (filter.id === currentState.filterId) {
            return assign(state, {
                loading: false
            });
        } else {
            const listState: ObiektListStatePart = assign(currentState, {
                filterId: filter.id,
                filterOwnerUserId: filter.ownerUserId,
                filterName: filter.name,
                data: assign(currentState.data, {
                    filterData: assign(currentState.data.filterData, filter.data.filterData),
                    listData: assign(currentState.data.listData, {
                        visibleMetadataIds: filter.data.listData.visibleMetadataIds,
                        sorts: filter.data.listData.sorts,
                        pagination: filter.data.listData.pagination,
                        editedItems: [],
                        columnWidths: filter.data.listData.columnWidths
                    })
                }),
                isSaving: false,
            });

            const stateByType: ObiektListStateByType = {};
            stateByType[ filter.listDefinitionType ] = listState;

            // nadpisanie stanu danymi z filtra i domyślnymi wartościami
            return assign(state,
                {
                    referrerUrl: null,

                    currentList: listState,
                    listDefinitionType: filter.listDefinitionType,
                    stateByType: assign(state.stateByType, stateByType),
                    loading: false
                }
            );
        }
    }),
    on(obiektListRestoreStateByType, (state, {listDefinitionType, readonlyFilterDataValues, filterDataValues}) => {
        // przywrócenie stanu jak jest zapamiętany
        const previousState = state.stateByType[ listDefinitionType ];
        if (previousState !== undefined && previousState !== null) {
            const currentState = assign(previousState, {
                data: assign(previousState.data, {
                    filterData: assign(previousState.data.filterData, {
                        // tu jest np. id obiektu dla którego jest podlista (id orzeczenia dla listy jego tez)
                        // jak nie nadpiszemy, a wcześniej było się na liście tez innego orzeczenia to będzie
                        // ładowała się lista tez tego poprzedniego orzeczenia
                        readonlyValues: readonlyFilterDataValues,
                        values: filterDataValues === undefined ? previousState.data.filterData.values : filterDataValues
                    })
                })
            });

            // ustalenie typu listy i wyczyszczenie niepotrzebnych danych
            const updatedState = assign(state, {
                referrerUrl: null,
                jednostkaAktuForTrescPreview: null,

                listDefinitionType: listDefinitionType,
                loading: false
            });
            // ustalenie aktualnego filtra
            return updateCurrentListState(updatedState, currentState);
        }
        return state;
    }),
    on(obiektListSetDefaultStateByTypeComplete, (state, {
        listDefinitionType,
        listDefinition,
        readonlyFilterDataValues,
        filterDataValues
    }) => {
        const visibleByDefault = (options: FilterOptions | DisplayOptions): boolean =>
            (options && (options.display === Display.Always || options.display === Display.Yes));

        const visibleColumnMetadataIds = listDefinition.metadata
            .filter(metadata => visibleByDefault(metadata.displayOptions))
            .map(metadata => metadata.id);

        const visibleFilterMetadataIds = listDefinition.metadata
            .filter(metadata => visibleByDefault(metadata.filterOptions))
            .map(metadata => metadata.id);

        const {defaultSortMetadataIds} = listDefinition;
        const sorts: Sort[] = [];
        for (const defaultSortMetadataId of defaultSortMetadataIds) {
            const direction = listDefinition.metadata
                .find(metadata => metadata.id === defaultSortMetadataId)
                .displayOptions.sort;

            const sort: Sort = {columnId: defaultSortMetadataId, direction: direction};
            sorts.push(sort);
        }

        const idsToSelect = state.selectedIdsByType[ listDefinitionType ] !== undefined;

        const listState = assign(INITIAL_STATE_PART, {
            data: {
                filterData: assign(INITIAL_STATE_PART.data.filterData, {
                    readonlyValues: readonlyFilterDataValues,
                    values: filterDataValues === undefined ? [] : filterDataValues,
                    visibleMetadataIds: visibleFilterMetadataIds,
                }),
                listData: assign(INITIAL_STATE_PART.data.listData, {
                    visibleMetadataIds: visibleColumnMetadataIds,
                    sorts: sorts,
                    selectedIds: idsToSelect ? state.selectedIdsByType[ listDefinitionType ] : []
                }),
            }
        });

        const selectedIdsByType = assign(state.selectedIdsByType, {}); // tworzenie kopii
        // usunięcie wykorzystanych idków
        if (idsToSelect) {
            selectedIdsByType[ listDefinitionType ] = undefined;
        }

        // ustalenie typu listy i wyczyszczenie niepotrzebnych danych
        const updatedState = assign(state, {
            referrerUrl: null,
            jednostkaAktuForTrescPreview: null,

            listDefinitionType: listDefinitionType,
            loading: false,
            selectedIdsByType: selectedIdsByType
        });

        // ustalenie aktualnego stanu
        return updateCurrentListState(updatedState, listState);
    }),
    on(obiektListDeleteStoredStateByType, (state, {listDefinitionType}) => {
        // tylko usunięcie z tablicy zapamiętanych stanów
        const stateByType: ObiektListStateByType = {};
        stateByType[ listDefinitionType ] = undefined;

        return assign(state, {
            stateByType: assign(state.stateByType, stateByType)
        });
    }),
    on(obiektListFilterDeleteComplete, (state, {id}) => {
        const currentState = getCurrentListState(state);
        let updatedState = currentState;
        let currentListDefinitionType = state.listDefinitionType;
        // usunięto aktualnie wybrany filtr
        if (currentState.filterId === id) {
            updatedState = INITIAL_STATE_PART;
            currentListDefinitionType = null;
        }
        // szukanie usuniętego filtra na liście filtrów dla typu listy
        const filterListDefinitionType = Object.keys(state.stateByType).filter(x => state.stateByType[ x ].id === id);
        // jak znalazło to podmieniamy go usuwamu, ustawiamy undefined
        if (filterListDefinitionType.length > 0) {
            const listDefinitionType = filterListDefinitionType[ 0 ];
            const stateByType: ObiektListStateByType = {};
            stateByType[ listDefinitionType ] = undefined;

            return assign(state, {
                currentList: updatedState,
                stateByType: assign(state.stateByType, stateByType)
            });
        }

        return assign(state, {
            listDefinitionType: currentListDefinitionType,
            currentList: updatedState
        });
    }),
    on(obiektListUpdateEditedItems, (state, {editedId}) => {

        const currentState = getCurrentListState(state);

        if (!currentState.data.listData.editedItems.includes(editedId)) {
            const updatedState = assign(currentState, {
                data: assign(currentState.data, {
                    listData: assign(currentState.data.listData, {
                        editedItems: [...currentState.data.listData.editedItems, editedId]
                    })
                })
            });
            return updateCurrentListState(state, updatedState);
        }
        return state;
    }),
    on(metadataPreviewInitialize, (state, {metadataPanelDefinitions}) => {
        let panels: MetadataPreviewPanel[] = [];
        // lista może nie mieć zdefiniowanego preview
        if (metadataPanelDefinitions !== null) {
            panels = metadataPanelDefinitions.map(panelDefinition => ({
                open: false,
                name: panelDefinition.name,
                data: null
            }));
        }

        const currentState = getCurrentListState(state);
        const updatedState = updateMetadataPreview(currentState, {panels: panels});
        return updateCurrentListState(state, updatedState);
    }),
    on(metadataPreviewOpenStart, (state, {id}) => {
        const currentState = getCurrentListState(state);
        // zapamiętujemy które belki były otwarte
        const previousPanels = currentState.data.listData.metadataPreview.panels.filter(x => x.open).map(x => x.name);
        // zamykamy wszystkie belki
        const panels = currentState.data.listData.metadataPreview.panels.map((item) =>
            Object.assign({}, item, {open: false, data: null})
        );
        const updatedState = updateMetadataPreview(currentState, {
            id,
            open: true,
            panels,
            previousPanels: previousPanels
        });
        return updateCurrentListState(state, updatedState);
    }),
    on(metadataPreviewClose, (state) => {
        const currentState = getCurrentListState(state);
        // zamykanie wszystkich paneli
        const panels = currentState.data.listData.metadataPreview.panels.map((item) =>
            Object.assign({}, item, {open: false, data: null})
        );
        const updatedState = updateMetadataPreview(currentState, {id: null, open: false, panels});
        return updateCurrentListState(state, updatedState);
    }),
    on(metadataPreviewOpenComplete, (state, {panel}) => {
        const currentState = getCurrentListState(state);
        const panels = currentState.data.listData.metadataPreview.panels.map((item) => {
            return item.name === panel.name ? panel : item;
        });
        const updatedState = updateMetadataPreview(currentState, {panels});
        return updateCurrentListState(state, updatedState);
    }),
    on(metadataPreviewPanelClose, (state, {name}) => {
        const currentFilterState = getCurrentListState(state);
        const panels = currentFilterState.data.listData.metadataPreview.panels.map((item) => {
            return item.name === name ? Object.assign({}, item, {open: false}) : item;
        });
        const updatedState = updateMetadataPreview(currentFilterState, {panels});
        return updateCurrentListState(state, updatedState);
    }),
    on(metadataPreviewShowTrescForJednostkaAktu, (state, {jednostkaAktu}) => assign(state, {jednostkaAktuForTrescPreview: jednostkaAktu})),
    on(obiektListUpdateLockData, (state, {obiektLocksData}) => {
        const columnData = obiektLocksData.lockDatas;
        const lockUserColumnValue = columnData && columnData.length > 0 ? JSON.stringify(columnData) : null;
        const columnsValues = [
            {columnName: ColumnsNameHelper.lockUserColumnId, data: lockUserColumnValue},
            {columnName: ColumnsNameHelper.lockCreationDateColumnId, data: obiektLocksData.lockCreationDate},
            {columnName: ColumnsNameHelper.lockUserIdColumnId, data: obiektLocksData.userId}
        ];
        return assign(state, {
            lockData: assign(state.lockData, {
                rowIdentifier: assign(state.lockData.rowIdentifier, {
                    columnName: ColumnsNameHelper.rootIdColumnId,
                    rowId: obiektLocksData.obiektId
                }),
                lockColumnsData: [...columnsValues]
            })
        });
    }),
    on(obiektListSetSubListParentObiektId, (state, {id, listDefinitionType}) => {
        return assign(state, {
            subListData: {parentObiektId: id, listDefinitionType: listDefinitionType}
        });
    })
);
